import React from 'react';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';

// Translations
import translate from '../Translate.js';

// Dependencies
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

const Graph = observer(class Graph extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.getFilters = this.getFilters.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.resetFilters = this.resetFilters.bind(this);

    // Set the initial state
    this.state = {
      isInstructor: false
    };
  }

  componentDidMount() {
    const { SessionStore } = this.props.store;
    const { userData } = SessionStore;

    if(userData && userData.role && userData.role.toLowerCase() === 'instructor') {
      this.setState({
        isInstructor: true
      }, () => {
        this.getFilters();
      });
    } else {
      this.getFilters();
    }
  }

  getFilters() {
    const { CourseStore } = this.props.store;

    if(CourseStore.courseOfferings.length === 0 && !this.state.isInstructor) {
      CourseStore.getCourseOfferings();
    } else if(!CourseStore.exams.length && this.state.isInstructor) {
      CourseStore.getExams();
    }
  }

  applyFilters(e) {
    if(e) {
      e.preventDefault();
    }

    const { ReportStore } = this.props.store;
    const courseOffering = this.courseOffering ? this.courseOffering.value : '';
    const exam = this.exam ? this.exam.value : '';
    const filters = {};

    if(courseOffering) {
      filters.courseOfferingSid = courseOffering;
    }

    if(exam) {
      filters.examSid = exam;
    }

    if(Object.keys(filters).length > 0) {
      ReportStore.getModalityGraphs(filters, true);
    } else {
      this.resetFilters();
    }
  }

  resetFilters() {
    const { ReportStore } = this.props.store;

    if(this.courseOffering) {
      this.courseOffering.value = '';
    }

    if(this.exam) {
      this.exam.value = '';
    }

    ReportStore.graphFilters = {};
    ReportStore.getModalityGraphs(null, true);
  }

  render() {
    const { data, hideFilterBar, title, translation } = this.props;
    const { CourseStore, ReportStore, SessionStore } = this.props.store;
    const animationDuration = 500;

    if(!SessionStore.loading) {
      return (
        <div>
          {!hideFilterBar &&
            <form
              className="filter"
              onSubmit={this.applyFilters}
            >
              <div className="wrap">
                <fieldset>
                  <ul className="fields fields--inline">
                    <li>
                      <legend>{translation.filter}:</legend>
                    </li>
                    {!this.state.isInstructor &&
                      <li>
                        <label className="select">
                          <select
                            ref={(input) => { this.courseOffering = input }}
                            defaultValue={ReportStore.graphFilters.courseOfferingSid || ''}
                          >
                            <option value="">{translation.all_offerings}</option>

                            {CourseStore.courseOfferings.map(
                              (offering, i) =>
                              <option key={i} value={offering.sid}>{offering.title}</option>
                            )}
                          </select>
                        </label>
                      </li>
                    }
                    {this.state.isInstructor &&
                      <li>
                        <label className="select">
                          <select
                            ref={(input) => { this.exam = input }}
                            defaultValue={ReportStore.graphFilters.examSid || ''}
                          >
                            <option value="">{translation.all_exams}</option>

                            {CourseStore.exams.map(
                              (exam, i) =>
                              <option key={i} value={exam.sid}>{exam.title}</option>
                            )}
                          </select>
                        </label>
                      </li>
                    }
                  </ul>
                </fieldset>
    
                <div className="actions">
                  <button
                    className="btn"
                    type="submit"
                  >
                    {translation.filter}
                  </button>
    
                  <button
                    className="btn btn--outline"
                    type="reset"
                    onClick={this.resetFilters}
                  >
                    {translation.reset}
                  </button>
                </div>
              </div>
            </form>
          }
  
          <div className="wrap">
            <div className="chart">
              {title &&
                <h3 className="chart__title">{title}</h3>
              }

              <ResponsiveContainer height={300}>
                <BarChart
                  data={toJS(data)}
                >
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />

                  {
                    !SessionStore.backgroundLoading &&
                    data.length &&
                    data[0].hasOwnProperty('value') &&
                    <Bar
                      animationDuration={animationDuration}
                      barSize={20}
                      dataKey="value"
                      fill="#0074cc"
                    />
                  }
      
                  {
                    !SessionStore.backgroundLoading &&
                    data.length &&
                    data[0].hasOwnProperty('total') &&
                    <Bar
                      animationDuration={animationDuration}
                      barSize={20}
                      dataKey="total"
                      fill="#47b8c6"
                    />
                  }
      
                  {
                    !SessionStore.backgroundLoading &&
                    data.length &&
                    data[0].hasOwnProperty('scheduled') &&
                    <Bar
                      animationDuration={animationDuration}
                      barSize={10}
                      dataKey="scheduled"
                      fill="#46be8a"
                    />
                  }
      
                  {
                    !SessionStore.backgroundLoading &&
                    data.length &&
                    data[0].hasOwnProperty('closed') &&
                    <Bar
                      animationDuration={animationDuration}
                      barSize={10}
                      dataKey="closed"
                      fill="#0074cc"
                    />
                  }
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      );
    }

    return null;
  }
})

export default translate('Graph')(Graph);



// WEBPACK FOOTER //
// ./src/app/components/Reports/Graph.js